import React from 'react';
import { CreditCard, Banknote, Building2, Wallet } from 'lucide-react';

interface PaymentMethodSelectorProps {
  selectedMethod: string;
  onMethodChange: (method: string) => void;
}

const PaymentMethodSelector: React.FC<PaymentMethodSelectorProps> = ({
  selectedMethod,
  onMethodChange
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        اختر طريقة الدفع
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Reflect Wallet */}
        <div
          className={`border-2 rounded-lg p-4 cursor-pointer transition-colors ${
            selectedMethod === 'reflect_wallet'
              ? 'border-amber-500 bg-amber-50 dark:bg-amber-900/20'
              : 'border-gray-300 dark:border-gray-600 hover:border-gray-400'
          }`}
          onClick={() => onMethodChange('reflect_wallet')}
        >
          <div className="flex items-center space-x-3">
            <Wallet className="h-6 w-6 text-amber-600" />
            <div>
              <h4 className="font-medium text-gray-900 dark:text-white">
                الدفع على محفظة ريفلكت
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                أرسل المبلغ إلى 0599554659 واذكر رقم الطلب
              </p>
            </div>
          </div>
        </div>

        {/* Cash on Delivery */}
        <div
          className={`border-2 rounded-lg p-4 cursor-pointer transition-colors ${
            selectedMethod === 'cash_on_delivery'
              ? 'border-green-500 bg-green-50 dark:bg-green-900/20'
              : 'border-gray-300 dark:border-gray-600 hover:border-gray-400'
          }`}
          onClick={() => onMethodChange('cash_on_delivery')}
        >
          <div className="flex items-center space-x-3">
            <Banknote className="h-6 w-6 text-green-600" />
            <div>
              <h4 className="font-medium text-gray-900 dark:text-white">
                الدفع عند الاستلام
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                دفع نقداً عند توصيل الطلب
              </p>
            </div>
          </div>
        </div>

        {/* Credit Card (Disabled for now) */}
        <div
          className={`border-2 rounded-lg p-4 cursor-not-allowed opacity-50 ${
            selectedMethod === 'credit_card'
              ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20'
              : 'border-gray-300 dark:border-gray-600'
          }`}
        >
          <div className="flex items-center space-x-3">
            <CreditCard className="h-6 w-6 text-purple-600" />
            <div>
              <h4 className="font-medium text-gray-900 dark:text-white">
                بطاقة ائتمان
              </h4>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                متاح قريباً
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Method Details */}
      {selectedMethod === 'bank_transfer' && (
        <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <h4 className="font-medium text-blue-900 dark:text-blue-100 mb-2">
            معلومات التحويل البنكي:
          </h4>
          <div className="text-sm text-blue-800 dark:text-blue-200 space-y-1">
            <p><strong>اسم البنك:</strong> Your Bank Name</p>
            <p><strong>اسم الحساب:</strong> Your Business Name</p>
            <p><strong>رقم الحساب:</strong> 1234567890</p>
            <p><strong>IBAN:</strong> PS123456789012345678901234</p>
          </div>
        </div>
      )}

      {selectedMethod === 'cash_on_delivery' && (
        <div className="mt-4 p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
          <h4 className="font-medium text-green-900 dark:text-green-100 mb-2">
            الدفع عند الاستلام:
          </h4>
          <div className="text-sm text-green-800 dark:text-green-200 space-y-1">
            <p>• سيتم دفع المبلغ نقداً عند توصيل الطلب</p>
            <p>• لا توجد رسوم إضافية</p>
            <p>• يمكنك فحص المنتجات قبل الدفع</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodSelector;
